/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import jApiAi from '@/services/jApiAi';

const state = {
  train_created: false,
  ai_updated: false,
};

const getters = {
};

const mutations = {
  trainCreated(state) {
    state.train_created = !state.train_created;
  },
  aiUpdated(state) {
    state.ai_updated = !state.ai_updated;
  },
};

const actions = {
  async deleteAi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const deleteAi = await jApiAi.deleteAi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', deleteAi.message, { root: true });
      return deleteAi;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async createAi({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let createAi;
    try {
      createAi = await jApiAi.createAi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', createAi.message, { root: true });
    } catch (err) {
      createAi = err.response;
    }
    return createAi;
  },

  async updateAi({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const updateAi = await jApiAi.updateAi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', updateAi.message, { root: true });
      commit('aiUpdated');
      return updateAi;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async trainAi({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    let trainAi;
    try {
      trainAi = await jApiAi.trainAi(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', trainAi.message, { root: true });
      commit('trainCreated');
    } catch (err) {
      trainAi = err.response;
    }
    return trainAi;
  },

  async getDetailAi({ dispatch }, data) {
    let res;
    try {
      res = await jApiAi.getDetailAi(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getModelAi({ dispatch }, data) {
    let res;
    try {
      res = await jApiAi.getModelAi(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreAi.js